'use client';

// Libraries
import dynamic from 'next/dynamic';

// Constants
import { LAYOUT } from '@/constants/config';

// Components
import Loading from '@/components/Loading';

// Variables
const TopBanner = dynamic(() => import('@/components/Home/TopBanner'), {
  ssr: false,
  loading: () => <Loading />,
});
const StatisticsAndModulesSection = dynamic(
  () => import('@/components/Home/StatisticsAndModulesSection'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
);
const CoreProduct = dynamic(() => import('@/components/Home/CoreProduct'), {
  ssr: false,
  loading: () => <Loading />,
});
const ExtendBusiness = dynamic(
  () => import('@/components/Home/ExtendBusiness'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
);
const StreamlineService = dynamic(
  () => import('@/components/Home/StreamlineService'),
  {
    ssr: false,
    loading: () => <Loading />,
  }
);
const DemoRequest = dynamic(() => import('@/components/Home/DemoRequest'), {
  ssr: false,
  loading: () => <Loading />,
});
const Testimonial = dynamic(() => import('@/components/Home/Testimonial'), {
  ssr: false,
  loading: () => <Loading />,
});

export default function Home() {
  return (
    <article className="home">
      <TopBanner />
      <StatisticsAndModulesSection />
      <CoreProduct />
      <ExtendBusiness />
      <StreamlineService />
      <DemoRequest />
      <Testimonial />
    </article>
  );
}

Home.layout = LAYOUT.HEADER_TRANSPARENT;
Home.title = 'common.meta.page.home';
